module.exports = __webpack_public_path__ + "img/ic_danger.1fc7d5ee.svg";